module.exports = __webpack_public_path__ + "static/media/hero-datos-abiertos.6ccd16d7.webp";